import { AxiosResponse } from 'axios';
import AxiosInstance from './AxiosInstance';

export const getConfigForwardChatOmnichannel = async (): Promise<AxiosResponse> =>
  AxiosInstance.get('settings/Livechat_agent_leave_action');
